import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// créer un rabais
export const createDiscount = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/discount/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un rabais spécifique
export const getDiscountByID = async (id_discount, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/discount/${id_discount}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer tous les rabais
export const getAllDiscounts = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/discount/all/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les rabais de type réduction
export const getDiscountsByType = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/discount/reduction/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les rabais de type bourse
export const getDiscountsByTypeBourse = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/discount/bourse/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les rabais pour un étudiant de type réduction
export const getDiscountsReductionByStudentID = async (
  id_academicYear,
  id_student,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/discount/reduction/${id_academicYear}/${id_student}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les rabais pour un étudiant de type bourse
export const getDiscountsBourseByStudentID = async (
  id_academicYear,
  id_student,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/discount/bourse/${id_academicYear}/${id_student}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// mettre à jour un rabais
export const updateDiscount = async (id_discount, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/discount/${id_discount}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un rabais
export const deleteDiscount = async (id_discount, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/discount/${id_discount}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------PDF-------------------------------------------------------

export const generateFicheBourse = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-fiche-bourse`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const generateFicheReduction = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-fiche-reduction`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

export const generateAnnualBourseReport = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-rapport-annuel-bourse`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

export const generateAnnualReductionReport = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-rapport-annuel-reduction`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};
